import { render, staticRenderFns } from "./LglRequirementEdit.vue?vue&type=template&id=5f1f7c2b&"
import script from "./LglRequirementEdit.vue?vue&type=script&lang=js&"
export * from "./LglRequirementEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports